import {
  REPRESENTATION_TYPE_OPTIONS,
  REPRESENTATION_TYPE_COUNTRY,
  REPRESENTATION_PROFILE_TYPES,
} from '../const/REPRESENTATIVE_OPTIONS';
import { KeyOfAddRepresentativesForm } from '../model/AddRepresentativeSchema';

type ReprsentativesFormProps = {
  name: string;
  value: {
    key: string;
    value: string;
  };
  options: {
    key: string;
    value: string;
  }[];
  key: KeyOfAddRepresentativesForm;
  handleAgencyInputChange?: (inputValue: string) => void;
};

type UseAddRepresentativesFormikFormProps = {
  representation_type: 'Agency Representation' | 'Non-Represented' | string;
  profile_type: string;
  country: string;
};

export const useAddRepresentativesForm = ({
  representation_type,
  profile_type,
  country,
}: UseAddRepresentativesFormikFormProps) => {
  const representatives_form: ReprsentativesFormProps[] = [
    {
      name: 'Representation Type',
      options: REPRESENTATION_TYPE_OPTIONS,
      value: {
        key: country === 'Australia' && representation_type === 'Non-Represented' ? 'Freelance' : representation_type,
        value: representation_type,
      },
      key: 'representation_type',
    },
    {
      name: 'Select Country',
      options: REPRESENTATION_TYPE_COUNTRY,
      value: {
        key: country,
        value: country,
      },
      key: 'country',
    },
    {
      name: 'Representation Type',
      options: REPRESENTATION_PROFILE_TYPES,
      value: {
        key: profile_type,
        value: profile_type,
      },
      key: 'profile_type',
    },
  ];

  return {
    representatives_form,
  };
};
